import { motion } from 'framer-motion'

export default function Footer() {
  const year = new Date().getFullYear()

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  return (
    <footer className="relative border-t border-[#30363d] bg-[#0d1117]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-10">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-6">
          {/* Logo + credit */}
          <div className="text-center sm:text-left">
            <div className="flex items-center gap-2 mb-1 justify-center sm:justify-start">
              <div className="w-7 h-7 border border-[#00ff41] rounded flex items-center justify-center font-mono text-xs font-bold text-[#00ff41]">
                SK
              </div>
              <span className="font-mono text-sm text-[#8b949e]">Seraj Khan</span>
            </div>
            <p className="font-mono text-xs text-[#6e7681]">
              Built with React + Framer Motion + Tailwind CSS
            </p>
          </div>

          {/* Terminal uptime line */}
          <div className="font-mono text-xs text-[#6e7681] text-center">
            <span className="text-[#00ff41]">$</span>{' '}
            echo &quot;© {year} Seraj Khan. All systems operational.&quot;
          </div>

          {/* Back to top */}
          <motion.button
            onClick={scrollToTop}
            className="flex items-center gap-2 font-mono text-xs text-[#6e7681] hover:text-[#00ff41] transition-colors border border-[#30363d] hover:border-[#00ff41]/40 px-4 py-2 rounded-lg"
            whileHover={{ y: -2 }}
            whileTap={{ y: 0 }}
          >
            <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2">
              <polyline points="18 15 12 9 6 15" />
            </svg>
            back to top
          </motion.button>
        </div>
      </div>

      <div className="h-px w-full bg-[#30363d]" />
    </footer>
  )
}
